"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param filename Filename without extension
 * @returns If its invalid or not according to Internxt's policy
 */
function isInvalidFilename(filename) {
    return !!filename.match(/[/\\]|^\s*$|.+\s+$|^\./);
}
exports.default = isInvalidFilename;
